import React from "react";
import { Formik } from "formik";
import FormInput from "../../../../../components/Universal/FormInput.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";

const Body = () => {
  const paymentModes = ["Cash", "Bank Transfer", "UPI", "Cheque"];
  const verifiers = ["Manager A", "Manager B", "Auditor X"];

  return (
    <Formik
      initialValues={{
        providerName: "",
        description: "",
        contact: "",
        topics: "",
        dealAmount: "",
        paidAmount: "",
        gst: "",
        duration: "",
        paymentMode: "",
        verifier: "",
      }}
      onSubmit={(values) => {
        console.log("Submitted:", values);
      }}
    >
      {({ values, handleSubmit, setFieldValue, touched, errors }) => (
        <form onSubmit={handleSubmit} className="p-1">
          <div className="grid grid-cols-2 gap-4 mb-4">
            <FormInput
              name="providerName"
              label="B2B provider/person"
              type="text"
              placeholder="Enter name influencer/page"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("providerName", e.target.value)
              }
            />

            <FormInput
              name="description"
              label="Description"
              type="text"
              placeholder="Type something here"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("description", e.target.value)
              }
            />

            <FormInput
              name="contact"
              label="Contact"
              type="text"
              placeholder="Enter phone number"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("contact", e.target.value)}
            />

            <FormInput
              name="topics"
              label="Promotional topics"
              type="text"
              placeholder="Enter promotional topic name"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("topics", e.target.value)}
            />

            <FormInput
              name="dealAmount"
              label="Deal amount (INR)"
              type="number"
              placeholder="Enter amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("dealAmount", e.target.value)
              }
            />

            <FormInput
              name="paidAmount"
              label="Paid amount (INR)"
              type="number"
              placeholder="Enter paid amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("paidAmount", e.target.value)
              }
            />

            <FormInput
              name="gst"
              label="GST (if any)"
              type="number"
              placeholder="Enter GST in %"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("gst", e.target.value)}
            />

            <FormInput
              name="duration"
              label="Duration"
              type="number"
              placeholder="Enter PR duration in days"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("duration", e.target.value)}
            />

            <DropDownInput
              name="paymentMode"
              label="Payment mode"
              value={values.paymentMode}
              placeholder="Choose payment mode"
              suggestionList={paymentModes}
              setFieldValue={(val) => setFieldValue("paymentMode", val)}
            />

            <DropDownInput
              name="verifier"
              label="Verifier"
              value={values.verifier}
              placeholder="Choose payment verifier"
              suggestionList={verifiers}
              setFieldValue={(val) => setFieldValue("verifier", val)}
            />
          </div>

          <button type="submit" className="actionBtn w-full mt-4">
            Collect
          </button>
        </form>
      )}
    </Formik>
  );
};

export default Body;
